import type { DemandDatesReportCase } from "@/queries/useFetchReportDemandDates.ts";
import { dateFormatterDashed } from "@/utils/mapDateOrStringToLocalDate.ts";
import { LocalDate } from "@js-joda/core";
import {
    type MRT_ColumnDef,
    type MRT_Row,
    MaterialReactTable,
    useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
    data: DemandDatesReportCase[];
};
const MrtCaseTableDemandDates = ({ data }: Props) => {
    const navigate = useNavigate();
    const handleRowClick = (row: MRT_Row<DemandDatesReportCase>) => {
        navigate(`/case-detail/${row.original.id}`);
    };

    const columns = useMemo<MRT_ColumnDef<DemandDatesReportCase>[]>(
        () => [
            {
                accessorKey: "id",
                header: "Case #",
                size: 50,
            },
            {
                accessorKey: "clientName",
                header: "Client Name",
            },
            {
                accessorKey: "caseType",
                header: "Type",
            },
            {
                accessorKey: "caseStatus",
                header: "Liability",
            },
            {
                accessorKey: "caseStatusUM",
                header: "UM",
            },
            {
                accessorKey: "demandLiabilitySentOn",
                header: "Liability Sent On",
                Cell: ({ renderedCellValue }) => {
                    if (renderedCellValue instanceof LocalDate) {
                        return renderedCellValue.format(dateFormatterDashed);
                    }

                    return "";
                },
            },
            {
                accessorKey: "demandUMSentOn",
                header: "UM Sent On",
                Cell: ({ renderedCellValue }) => {
                    if (renderedCellValue instanceof LocalDate) {
                        return renderedCellValue.format(dateFormatterDashed);
                    }

                    return "";
                },
            },
            {
                accessorKey: "AssignedToAttorney_Pretty",
                header: "Assigned To",
            },
            {
                accessorKey: "assignedTeam",
                header: "Team",
            },
        ],
        [],
    );

    const table = useMaterialReactTable({
        columns,
        data: data,
        initialState: {
            showColumnFilters: false,
            showGlobalFilter: true,
            density: "compact",
        },

        // top toolbar
        enableTopToolbar: true,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        enableHiding: false,
        enableColumnFilters: false,

        manualFiltering: true,
        manualPagination: true,
        manualSorting: true,

        enablePagination: false,
        enableBottomToolbar: false,
        muiTableBodyRowProps: ({ row }: { row: MRT_Row<DemandDatesReportCase> }) => ({
            onClick: () => handleRowClick(row),
            sx: { cursor: "pointer" },
        }),
    });

    if (data === undefined) {
        return <div>No data</div>;
    }

    return <MaterialReactTable table={table} />;
};

export default MrtCaseTableDemandDates;
